import React, { useState, useContext, useEffect } from 'react';
import classNames from 'classnames';
import { Outlet } from 'react-router-dom';
import MessagingContacts from './components/MessagingContacts';
import NewMessageModal from './components/modals/NewMessageModal';
import MessagingContext from './providers/Messaging/Messaging.context';
import ContactPreview from 'router/subrouters/Dash/subrouters/private/subrouters/Messaging/components/ContactPreview';
import { MainLayoutContext } from 'router/subrouters/Dash/Dash.router';

import './Messaging.styles.scss';
import './Messaging.styles.responsive.scss';

const MessagingRouter: React.FC = () => {
  const [modalOpened, setModalOpened] = useState<boolean>(false);
  const { contactOpen, currentSession, contactsOpen } =
    useContext(MessagingContext);
  const { addMainClassName, resetMainClassName } =
    useContext(MainLayoutContext);

  const classes = classNames('messaging-router');

  useEffect(() => {
    addMainClassName('dash-messaging');

    return () => {
      resetMainClassName();
    };
  }, [addMainClassName, resetMainClassName]);

  return (
    <div className={classes}>
      <NewMessageModal
        open={modalOpened}
        onClose={() => setModalOpened(false)}
      />

      <MessagingContacts
        onNewMessage={() => setModalOpened(true)}
        className={classNames('messaging-router__contacts', {
          'messaging-router__contacts--open': contactsOpen,
          'messaging-router__contacts--empty-sessions': !currentSession,
        })}
      />

      <div
        className={classNames('messaging-router__chat', {
          'messaging-router__chat--open': !contactsOpen && !contactOpen,
        })}
      >
        <Outlet />
      </div>

      <ContactPreview
        className={classNames('messaging-router__contact', {
          'messaging-router__contact--open': contactOpen,
        })}
      />
    </div>
  );
};

export default MessagingRouter;
